import { useNavigate } from 'react-router-dom'

export const PALLETS_LIST_URL = '/assembly/detail/:transferId/pallets'

export const useGoToPalletsList = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string) => {
      navigate(PALLETS_LIST_URL.replace(':transferId', transferId))
    }
  }
}
